import { createUseStyles } from 'react-jss';
import { IQuestionConfig } from '../core/IQuestion';
import { IGenericQuestionProvider } from '../core/question-provider/IQuestionProvider';
import { MiniWizardViewModel } from '../core/MiniWizardViewModel';
import { Step } from '../../Step';
import { IonCheckbox } from '@ionic/react';

const name = 'checkbox' as const;
type ICheckboxName = typeof name;
interface ICheckboxConfig { checkboxLabel: string };

export type ICheckboxQuestion = IQuestionConfig<ICheckboxName, boolean, ICheckboxConfig >;

export class CheckboxQuestionProvider implements IGenericQuestionProvider<ICheckboxQuestion> {
    questionType = 'checkbox';

    validate = (question: ICheckboxQuestion) => question.answer === true;

    render = (question: ICheckboxQuestion, wizard: MiniWizardViewModel) => {
        return <CheckboxStepV2 question={question} wizard={wizard} />;
    };
}

const useStyles = createUseStyles({
    label: {
        paddingTop: 15,
        color: 'var(--ion-color-step-700)',
        '& p': {
            marginTop: -3
        }
    }
});

export const CheckboxStepV2: React.FC<{ question: ICheckboxQuestion; wizard: MiniWizardViewModel  }> = ({ question, wizard }) => {
    const classes = useStyles();

    const handleChange = (newValue: boolean) => {
        wizard.answer(newValue);
    };

    return (
        <Step question={question.questionTitle} subTitle={question.subTitle}>
            <div style={{display: 'flex', alignItems: 'start'}}>
                <div style={{padding: 15}} onClick={() => handleChange(!question.answer)}>
                    <IonCheckbox
                        // disabled={disabled}
                        checked={question.answer}
                        onClick={(e) => e.stopPropagation()}
                        onIonChange={e => handleChange(e.detail.checked)}
                    />
                </div>

                {/* render label separately because IonCheckbox won't let us set alignment */}
                <div className={classes.label} onClick={() => handleChange(!question.answer)}>
                    {question.checkboxLabel.split('\n').map((para, idx) => (
                        <p key={`label-key-${idx}`}>{para}</p>
                    ))}
                </div>
            </div>
        </Step>
    );
};
